module.exports = __webpack_public_path__ + "static/media/typicons.a509074c.eot";